import { useEffect, useState } from "react";
import axios from 'axios';
import Loading from "../../../component/common/loading/Loading.jsx";
import PieChart from "./PieChart.jsx";

import '../../../css/data-grid.css';

const Incurr_popup = () => {

    const [data, setData] = useState([{}]);
    const [isWholeLoading, setIsWholeLoading] = useState(false);

    const sendData = JSON.parse(localStorage.getItem('incurrData'));

    const popupData = async () => {
        try {
            const response = await axios.get('/trmsapi/hospitalvisit/bdtongtrms_stat_of_hospital_visit_popup_data.do',
                { params: sendData }
            );
            setData(response.data);
            setIsWholeLoading(false);
        } catch (e) {
            console.error('body 내용 로딩 중 오류 발생', e);
        }
    }

    useEffect(() => {
        setIsWholeLoading(true);
        popupData();
    }, []);

    return (
        <div className='incurr'>
            {isWholeLoading ? <Loading /> : 
                <div className='pie'>
                    <PieChart
                        data={data}
                    />
                </div>
            }
        </div>
    )
}

export default Incurr_popup;